import { Button, Modal, message } from 'antd';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';

interface Props {
  id: string;
  title: string;
}

/** 刪除整篇文章（含 SEO/關聯/分類/標籤），需二次確認；成功後回列表。 */
export default function DeleteArticleButton({ id, title }: Props) {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const del = useMutation({
    mutationFn: () => api.deleteArticle(id),
    onSuccess: () => {
      message.success('文章已刪除');
      qc.invalidateQueries({ queryKey: ['articles'] });
      navigate('/articles');
    },
    onError: (e: Error) => message.error(e.message),
  });

  const confirm = () => {
    Modal.confirm({
      title: '確定刪除這篇文章？',
      icon: <ExclamationCircleFilled />,
      content: `「${title || '未命名草稿'}」刪除後無法復原，包含 SEO、關聯、分類與標籤關係。`,
      okText: '刪除',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => del.mutateAsync(),
    });
  };

  return (
    <Button danger block icon={<DeleteOutlined />} loading={del.isPending} onClick={confirm}>
      刪除文章
    </Button>
  );
}
